export default "__VITE_ASSET__KY$tevP5__"